"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var config_1 = require("../config");

var Avatar =
/** @class */
function (_super) {
  __extends(Avatar, _super);

  function Avatar(props) {
    var _this = _super.call(this, props) || this;

    _this.onError = function () {
      _this.setState({
        uri: undefined
      });
    };

    _this.state = {
      uri: props.uri,
      prevPropsUri: props.uri
    };
    return _this;
  }

  Avatar.getDerivedStateFromProps = function (props, state) {
    if (props.uri !== state.prevPropsUri) {
      return {
        prevPropsUri: props.uri,
        uri: props.uri
      };
    }

    return null;
  };

  Avatar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        size = _a.size,
        uri = _a.uri;
    var b = config_1.block('avatar');
    var style = {
      width: size,
      height: size
    };

    if (this.state.uri) {
      style.backgroundImage = "url(" + this.state.uri + ")";
    }

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("img", {
      style: {
        display: 'none',
        width: 0,
        height: 0
      },
      src: uri,
      onError: this.onError
    }), react_1.default.createElement("div", {
      className: b({}).mix(className),
      style: style
    }));
  };

  return Avatar;
}(react_1.default.Component);

exports.default = Avatar;